function hex2RGBA(hex) {
  var r = parseInt(hex.slice(1, 3), 16);
  var g = parseInt(hex.slice(3, 5), 16);
  var b = parseInt(hex.slice(5, 7), 16);
  var a = parseInt(hex.slice(7, 9) || "FF", 16);
  return "rgba(".concat(r, ",").concat(g, ",").concat(b, ",").concat((a / 255).toFixed(2), ")");
}

export { hex2RGBA };
